export const AgeGroupSliderSettings = {
	arrows: false,
	infinite: false,
	slidesToShow: 6,
	rtl: false,
	customPaging: () => {
		return (
			<span>
				<svg
					class="mp-bullet"
					width="15"
					height="13"
					viewBox="0 0 15 13"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<mask id="path-1-inside-1123" fill="white">
						<path
							fill-rule="evenodd"
							clip-rule="evenodd"
							d="M2.28226 0.915949C3.4251 0.0121103 6.44615 -0.00972253 7.87329 0.0016632C9.30036 0.0130489 11.6833 0.626532 12.6208 1.7627C13.5431 2.8805 14.8075 4.77877 14.9216 6.25716C15.0051 7.33979 15.1382 8.8267 14.6046 9.77809C14.0345 10.7943 12.5147 12.0465 11.6163 12.5682C9.84897 13.5944 4.22722 12.6217 2.56234 11.4215C-0.665824 9.09417 -0.937261 3.46227 2.28226 0.915949Z"
						/>
					</mask>
					<path
						d="M7.87329 0.0016632L7.89723 -2.99824H7.89723L7.87329 0.0016632ZM12.6208 1.7627L14.9347 -0.146638L14.9347 -0.146656L12.6208 1.7627ZM14.9216 6.25716L11.9305 6.48793L11.9305 6.48796L14.9216 6.25716ZM14.6046 9.77809L17.221 11.2458L17.221 11.2458L14.6046 9.77809ZM11.6163 12.5682L10.1098 9.97385L10.1097 9.97386L11.6163 12.5682ZM2.56234 11.4215L0.807921 13.855L0.807962 13.855L2.56234 11.4215ZM4.14322 3.269C3.97668 3.40071 3.94054 3.36364 4.23713 3.2816C4.49322 3.21076 4.84993 3.14645 5.29535 3.09803C6.18739 3.00107 7.15209 2.996 7.84936 3.00157L7.89723 -2.99824C7.16736 -3.00406 5.90795 -3.0039 4.64698 -2.86684C4.01589 -2.79824 3.31385 -2.68833 2.63747 -2.50123C2.00159 -2.32533 1.15925 -2.02073 0.421298 -1.4371L4.14322 3.269ZM7.84936 3.00157C8.21442 3.00448 8.85504 3.09767 9.48275 3.30671C9.78366 3.40692 10.0213 3.51412 10.1867 3.60939C10.3647 3.71189 10.3709 3.74966 10.3068 3.67205L14.9347 -0.146656C13.9281 -1.3666 12.4516 -2.02856 11.3785 -2.38594C10.2236 -2.77053 8.95923 -2.98977 7.89723 -2.99824L7.84936 3.00157ZM10.3068 3.67203C10.6796 4.12382 11.1153 4.72831 11.4542 5.33592C11.6219 5.63663 11.747 5.90451 11.8295 6.12794C11.87 6.23755 11.896 6.32498 11.9118 6.39052C11.9278 6.45676 11.9305 6.48807 11.9305 6.48793L17.9127 6.02639C17.8058 4.64083 17.2126 3.34282 16.6944 2.41349C16.1419 1.42292 15.4843 0.519376 14.9347 -0.146638L10.3068 3.67203ZM11.9305 6.48796C11.9759 7.07735 12.012 7.53588 11.9965 7.95675C11.9893 8.15367 11.9717 8.28332 11.9557 8.35897C11.9393 8.4368 11.9358 8.40369 11.9881 8.3104L17.221 11.2458C17.8355 10.1503 17.9633 8.97192 17.9925 8.17693C18.023 7.34583 17.9507 6.5196 17.9127 6.02636L11.9305 6.48796ZM11.9881 8.31036C11.9898 8.30742 11.9756 8.33264 11.9362 8.38604C11.8977 8.43811 11.8441 8.50499 11.7732 8.58535C11.6295 8.74834 11.4445 8.9333 11.2308 9.12496C10.7848 9.52483 10.3451 9.8372 10.1098 9.97385L13.1228 15.1625C13.7859 14.7774 14.5552 14.2028 15.2363 13.5921C15.8828 13.0125 16.6947 12.1839 17.221 11.2458L11.9881 8.31036ZM10.1097 9.97386C10.3146 9.85491 10.2342 9.96464 9.56161 9.99348C8.99316 10.0179 8.26554 9.97405 7.4797 9.86056C6.69982 9.74793 5.9403 9.57793 5.31723 9.38524C5.00696 9.28928 4.75552 9.19539 4.56654 9.11212C4.36502 9.02332 4.2978 8.97428 4.31671 8.98792L0.807962 13.855C1.62104 14.4412 2.65412 14.842 3.54449 15.1174C4.49897 15.4126 5.56752 15.6467 6.62209 15.7989C7.6707 15.9504 8.78395 16.0323 9.81866 15.988C10.7492 15.9481 12.0343 15.7945 13.1228 15.1625L10.1097 9.97386ZM4.31675 8.98795C3.60447 8.47443 3.04675 7.43831 3.00267 6.14837C2.95895 4.86914 3.43506 3.82908 4.14326 3.26896L0.421257 -1.43706C-2.09006 0.549143 -3.08799 3.59819 -2.99383 6.35331C-2.90004 9.09773 -1.70796 12.0412 0.807921 13.855L4.31675 8.98795Z"
						fill="#ECA1B0"
						mask="url(#path-1-inside-1123)"
					/>
				</svg>
				<svg
					class="mp-bullet-active"
					width="15"
					height="13"
					viewBox="0 0 15 13"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						fill-rule="evenodd"
						clip-rule="evenodd"
						d="M2.28226 0.915949C3.4251 0.0121103 6.44615 -0.00972253 7.87329 0.0016632C9.30036 0.0130489 11.6833 0.626532 12.6208 1.7627C13.5431 2.8805 14.8075 4.77877 14.9216 6.25716C15.0051 7.33979 15.1382 8.8267 14.6046 9.77809C14.0345 10.7943 12.5147 12.0465 11.6163 12.5682C9.84897 13.5944 4.22722 12.6217 2.56234 11.4215C-0.665824 9.09417 -0.937261 3.46227 2.28226 0.915949Z"
						fill="#ECA1B0"
					/>
				</svg>
			</span>
		);
	},
	responsive: [
		// {
		// 	breakpoint: 5000,
		// 	settings: {
		// 		slidesToShow: 6,
		// 		slidesToScroll: 6,
		// 		dots: true,
		// 	},
		// },
		{
			breakpoint: 1180,
			settings: {
				slidesToShow: 5,
				slidesToScroll: 1,
				dots: true,
			},
		},
		{
			breakpoint: 1024,
			settings: {
				slidesToShow: 4,
				slidesToScroll: 1,
				dots: true,
			},
		},
		{
			breakpoint: 890,
			settings: {
				slidesToShow: 3,
				slidesToScroll: 1,
				dots: true,
			},
		},
		{
			breakpoint: 600,
			settings: {
				slidesToShow: 2,
				slidesToScroll: 1,
				dots: true,
			},
		},
		{
			breakpoint: 400,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1,
				dots: true,
			},
		},
	],
};
